// extracted by mini-css-extract-plugin
export default {"rewardLandingContainer":"RewardLanding_rewardLandingContainer__FVXPi"};